export const getProductosFromDocumentedSale = (easyStoreSale) => {
    const productos = easyStoreSale.productos;
    if (productos.ventaItemListaDatosList.constructor !== Array) {
        productos.ventaItemListaDatosList = [productos.ventaItemListaDatosList];
    }

    return productos;
};